import * as EventTypes from 'actions/internal';
import { split } from 'lodash';
import { accountPlayersColumnsKeys } from 'components/helpers/TableHelpers';

const defaultState = () => {
  const lsColumns = localStorage.getItem('ap:columns');
  return {
    apColumns: lsColumns ? split(lsColumns, ',') : accountPlayersColumnsKeys(),
  }
};

export default function auth(state = defaultState(), action) {
  switch (action.type) {
    case EventTypes.AP_COLUMNS_VISIBILITY_CHANGED:
      localStorage.setItem('ap:columns', action.meta.options);
      return { ...state, apColumns: split(action.meta.options, ',') };
    default:
      return state;
  }
}
